<template>
    <b-container fluid="fluid">
        <fieldset :disabled="sending">
        <b-row>
            <b-col class="border" cols="9">
                <b-row class="border">
                    <b-col>
                        <b-row>
                                <b-col>
                                    <div class="text-right">
                                        {{$t('device_group_actions.id_or_imei_list')}}:
                                    </div>

                                </b-col>
                                <b-col>
<!--                                    rules="regexp='\d+[\,\.\;\:][ ]{0,}+\d'"-->
                                    <validation-provider
                                        name="custom_id_or_imei_list"
                                        :rules="{ regex: /^[\d ]+$/ }"
                                        v-slot="validationContext"
                                    >
                                        <b-form-group
                                            label-for="custom_id_or_imei_list"
                                            id='g_custom_id_or_imei_list'
                                            class="mt-0"
                                        >
                                          <b-form-textarea
                                            id="custom_id_or_imei_list"
                                            :formatter="formatBulkIdentifiers"
                                            v-model="customIdOrImeiList.raw"
                                            :state="getValidationState(validationContext)"
                                            class="mb-2 mr-sm-2 mb-sm-0"
                                            :placeholder="$t('device_group_actions.id_or_imei_list.placeholder')"
                                            aria-describedby="custom_id_or_imei_list-feedback"
                                        />
                                            <div>
                                                {{$t('device_group_actions.id_or_imei_list.help')}}
                                            </div>
                                        <b-form-invalid-feedback
                                            id='custom_id_or_imei_list-feedback'
                                        >{{$t('device_group_actions.id_or_imei_list.error')}}
                                        </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>
                        </b-row>
<!--                        <b-row>-->
<!--                                <b-col>-->
<!--                                    <div class="text-right">-->
<!--                                        {{$t('device_group_actions.id_or_imei_list_selected')}}:-->
<!--                                    </div>-->

<!--                                </b-col>-->
<!--                                <b-col>-->
<!--&lt;!&ndash;                                    rules="regexp='\d+[\,\.\;\:][ ]{0,}+\d'"&ndash;&gt;-->
<!--                                    <validation-provider-->
<!--                                        name="custom_id_or_imei_list_selected"-->
<!--                                        :rules="{ regex: /^[\d+,.;: ]+$/ }"-->
<!--                                        v-slot="validationContext"-->
<!--                                    >-->
<!--                                        <b-form-group-->
<!--                                            label-for="custom_id_or_imei_list_selected"-->
<!--                                            id='g_custom_id_or_imei_list_selected'-->
<!--                                            class="mt-0"-->
<!--                                        >-->
<!--                                          <b-form-textarea-->
<!--                                            id="custom_id_or_imei_list_selected"-->
<!--                                            @keyup="refreshTable"-->
<!--                                            @keydown="refreshTable"-->
<!--                                            @keypress="refreshTable"-->
<!--                                            disabled-->
<!--                                            v-model="selectedCustomDeviceListSting"-->
<!--                                            :state="getValidationState(validationContext)"-->
<!--                                            class="mb-2 mr-sm-2 mb-sm-0"-->
<!--                                            :placeholder="$t('device_group_actions.id_or_imei_list_selected.placeholder')"-->
<!--                                            aria-describedby="custom_id_or_imei_list_selected-feedback"-->
<!--                                        />-->
<!--                                            <div>-->
<!--                                                {{$t('device_group_actions.id_or_imei_list_selected.help')}}-->
<!--                                            </div>-->
<!--                                        <b-form-invalid-feedback-->
<!--                                            id='custom_id_or_imei_list_selected-feedback'-->
<!--                                        >{{$t('device_group_actions.id_or_imei_list_selected.error')}}-->
<!--                                        </b-form-invalid-feedback>-->
<!--                                        </b-form-group>-->
<!--                                    </validation-provider>-->
<!--                                </b-col>-->
<!--                        </b-row>-->
                        <b-row>
                            <b-col>
                            <div class="text-right">
                                {{$t('device_group_actions.type')}}:
                            </div>
                            </b-col>
                            <b-col>
                            <b-form-select
                                id="device_type"
                                v-model="filters['type']"
                                :options="getDictionary('deviceType')"
                                value-field="id"
                                text-field="name"
                            />
                            </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                          <div class="text-right">
                              {{$t('device_group_actions.firmware')}}:
                          </div>
                          </b-col>
                          <b-col>
                          <b-input
                              id = 'firmwareCurrent'
                              v-model="filters['firmwareCurrent']"
                          />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                          <div class="text-right">
                              {{$t('device_group_actions.distributor')}}:
                          </div>
                          </b-col>
                          <b-col>
                          <b-input
                              id="distributor"
                              v-model="filters['distributor']"
                          />
                          </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-row>
                      <b-col sm="4" offset="2"><span class="text-nowrap">{{$t('devices_selected')+ ': ' + rows}}</span></b-col>
                      <b-col sm="4" offset-md="2">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                        >

                        </b-pagination>
                      </b-col>
                    </b-row>
                </b-row>
                <b-row>
                    <b-table dark
                            :busy.sync="isBusy"
                            ref="deviceGroupActionsTable"
                            id="device-group_actions-table"
                            :items="myProvider"
                            :per-page="perPage"
                            :current-page="currentPage"
                            head-variant="dark"
                            stacked="md"
                            small
                            :fields="fields"
                            no-local-sorting
                            striped
                            :filter="filters"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            primary-key="id"
                            @refreshed="onTableRefreshed"
                    >
                      <template v-slot:head()="scope">

                        <div class="text-nowrap">
                          {{  $t(scope.label) }}
                        </div>
                      </template>
<!--                        <template v-slot:cell(selected)="row">-->
<!--                            <b-checkbox-->
<!--                                style="width: 30px"-->
<!--                                @change="onRowSelect($event, row.item.customId)"-->
<!--                            ></b-checkbox>-->
<!--                        </template>-->
                        <template v-slot:cell(firmwareCurrent)="row">
                            <div v-if="row.item.isFirmwareActual">
                                {{row.item.firmwareCurrent}}
                            </div>
                            <div v-else>
                                <span style="color: #dc3545">{{row.item.firmwareCurrent}}  >></span> <span style="color: #28a745">{{row.item.firmwareUpdate}}</span> ({{row.item.firmwareLoadPercent}}%)
                            </div>
                        </template>
                    </b-table>
                </b-row>

            </b-col>
            <b-col class="border" cols="3">
                <b-row>
                    <b-container fluid="fluid">
                    <b-card-header>
                      <b-row>
                        <b-col cols="2">
                          <icon-base icon-name="set-firmware"><set-firmware /></icon-base>
                        </b-col>
                        <b-col cols="10">
                          <span class="text-nowrap">{{$t('device_group_actions.set_firmware')}}</span>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <b-form
                        @submit.prevent="updateDevicesFirmware"
                    >
                        <b-form-group>
                            <b-form-select
                                v-model="filters.type"
                                :options="deviceTypeList"
                                value-field="id"
                                text-field="name"
                            >
                            </b-form-select>
                        </b-form-group>

                        <b-form-group>
                            <b-form-select
                                v-model="deviceChangeFirmware"
                                :options="deviceChangeFirmwareList"
                                value-field="id"
                                text-field="version"
                            >

                            </b-form-select>
                            <div class="border-1">
                                {{getChangeFirmwareDescription()}}
                            </div>
                        </b-form-group>
                        <b-alert v-model="showSuccessAlertDeviceChangeFirmwareList" variant="success" dismissible>
                            {{$t('saved_successful')}} {{showSuccessAlertDeviceChangeFirmwareListCount}}
                        </b-alert>

                        <b-button :disabled="sending || criteriaInvalid || isBusy || rows < 1 || (filters.type === null) || (deviceChangeFirmware === null)" type="submit"
                        >{{$t('device_group_actions.apply_to')}} {{getSelectedCount()}}</b-button>
                    </b-form>
                    </b-container>
                </b-row>
                <b-row>
                    <b-container fluid="fluid">
                    <b-card-header>
                      <b-row>
                        <b-col cols="2">
                        <icon-base icon-name="set-configuration"><set-configuration /></icon-base>
                        </b-col>
                        <b-col cols="10">
                          <span class="text-nowrap">{{$t('device_group_actions.set_configuration')}}</span>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <b-form @submit.prevent="updateDevicesConfigurations">
                        <b-form-group>
                        <b-form-select
                            v-model="filters.type"
                            :options="deviceTypeList"
                            value-field="id"
                            text-field="name"
                        >

                        </b-form-select>

                        </b-form-group>

                        <b-form-group>
                            <b-form-select
                                v-model="deviceChangeConfiguration"
                                :options="deviceChangeConfigurationList"
                                value-field="id"
                                text-field="name"
                            >

                            </b-form-select>
                        </b-form-group>

                        <b-alert v-model="showSuccessAlertDeviceChangeConfigurationList" variant="success" dismissible>
                            {{$t('saved_successful')}} {{showSuccessAlertDeviceChangeConfigurationListCount}}
                        </b-alert>

                        <b-button :disabled="sending || criteriaInvalid || isBusy || rows < 1 || (deviceChangeConfiguration === null) || (filters.type === null)" type="submit">{{$t('device_group_actions.apply_to')}} {{getSelectedCount()}} </b-button>
                    </b-form>

                    </b-container>
                </b-row>
                <b-row v-if="deviceChangeDistributorAvailable">
                    <b-container fluid="fluid">
                    <b-card-header>
                      <b-row>
                        <b-col cols="2">
                      <icon-base icon-name="set-configuration"><set-organisation /></icon-base>
                        </b-col>
                        <b-col cols="10">
                          <span class="text-nowrap">{{$t('device_group_actions.set_distributor')}}</span>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <b-form @submit.prevent="updateDevicesDistributors">

<!--                        <b-form-group>-->
<!--                            111111 {{roleCrossSiteDeviceMoveAvailable}}-->
<!--                        </b-form-group>-->

                        <b-form-group>
                        <b-form-input
                            v-model="distributorFilterPrefixFilterPrefix"
                            @keyup="filterDistributorList"
                            :placeholder="$t('organisation_filter')"
                        >

                        </b-form-input>

                        </b-form-group>
                        <b-form-group>
                            <b-form-select
                                v-model="deviceChangeDistributor"
                                :options="deviceChangeDistributorList"
                                value-field="id"
                                text-field="name"
                            >

                            </b-form-select>
                        </b-form-group>

                        <b-alert v-model="showSuccessAlertDeviceChangeDistributorList" variant="success" dismissible>
                            {{$t('saved_successful')}} {{showSuccessAlertDeviceChangeDistributorListCount}}
                        </b-alert>

                        <b-button :disabled="sending || criteriaInvalid || isBusy || rows < 1 || (deviceChangeDistributor === null || changeDevicesAvailable === false)" type="submit">{{$t('device_group_actions.apply_to')}} {{getSelectedCount()}} </b-button>
                    </b-form>
                    </b-container>
                </b-row>
            </b-col>
        </b-row>
        <div v-if="operationError" class="text-danger bulk-error">{{$t('bulk_action_error')}}</div>
        <b-button v-if="operationError" class="bulk-retry" type="button" :disabled="sending || isBusy" @click="retryLoads">{{$t('retry')}}</b-button>
        <div v-if="criteriaInvalid" class="text-danger bulk-criteria-error">{{$t('bulk_criteria_invalid')}}</div>
        </fieldset>
    </b-container>
</template>

<script>
    import axios from "axios";
    import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";
    import { formatBulkIdentifiers } from "../../utils/BulkIdentifiers";

    import IconBase from "../Icons/IconBase30.vue";
    import SetConfiguration from "../Icons/icons/SetConfiguration.vue";
    import SetFirmware from "../Icons/icons/SetFirmware.vue";
    import SetOrganisation from "../Icons/icons/SetOrganisation.vue";

    export default {
        name: "DeviceGroupActions",
        props: [
            "customIdOrImeiListRaw"
        ],
        components: {
          IconBase,
          SetConfiguration,
          SetFirmware,
          SetOrganisation,
        },
        data() {
            return {
                tableRefreshPending: false,
                isBusy: false, sending: false, operationError: false, disposed: false, providerRequest: 0, lookupRequest: 0, distributorRequest: 0, criteriaVersion: 0,
                perPage: Math.floor(document.documentElement.clientHeight/56),
                currentPage: 1,
                rows: 0,
                sortBy: 'customId',
                sortDesc: true,
                fields: [
                    // {
                    //     key: 'selected',
                    //     sortable: false,
                    //     stickyColumn: true,
                    //     label_t: '✓',
                    //     visible: true,
                    //     order: 1,
                    //     width: 30,
                    //     class: 'text-center p-0',
                    // },
                    {
                        key: 'customId',
                        label: this.$t('device_list.coll.header.id'),
                        sortable: true,
                        filtered: true,
                        width: 70,
                        visible: true,
                        order: 4
                    },
                    {
                        key: 'imei',
                        label: this.$t('device_list.coll.header.imei'),
                        sortable: true,
                        filtered: true,
                        width: 150,
                        visible: true,
                        order: 5
                    },
                    {
                        key: 'type',
                        label: this.$t('device_list.coll.header.type'),
                        sortable: true,
                        filtered: true,
                        width: 100,
                        filteredType: 'select',
                        dictionaryName: 'deviceType',
                        visible: true,
                        order: 6
                    },
                    {
                        key: 'firmwareCurrent',
                        label: this.$t('device_list.coll.header.firmware'),
                        sortable: true,
                        filtered: true,
                        width: 50,
                        visible: true,
                        order: 9
                    },
                    {
                        key: 'distributor',
                        label: this.$t('device_list.coll.header.distributor'),
                        sortable: true,
                        visible: true,
                        order: 10
                    }
                ],
                firmwareRequest: 0, configurationRequest: 0,
                deviceChangeFirmware: null,
                deviceChangeFirmwareList: [
                  {
                    id: null,
                    version: this.$t('select_firmware'),
                  }
                ],
                deviceChangeFirmwareListHash: [],
                showSuccessAlertDeviceChangeFirmwareList: false,
                showSuccessAlertDeviceChangeFirmwareListCount: null,
                deviceChangeConfiguration: null,
                deviceChangeConfigurationList: [
                  {
                    id: null,
                    name: this.$t('select_configuration')
                  }
                ],
                selectedCustomDeviceList: [],
                changeDevicesAvailable: false,
                showSuccessAlertDeviceChangeConfigurationList: false,
                showSuccessAlertDeviceChangeConfigurationListCount: null,
                deviceChangeDistributor: null,
                deviceChangeDistributorAvailable: false,
                roleCrossSiteDeviceMoveAvailable: false,
                selectedCustomDeviceListSting: null,
                deviceChangeDistributorList: [
                    {
                      id: null,
                      name: this.$t('select_organisation')
                    }
                ],
                deviceChangeAllDistributorList: [

                ],
                showSuccessAlertDeviceChangeDistributorList: false,
                showSuccessAlertDeviceChangeDistributorListCount: null,
                deviceTypeList: [
                  {
                    id: null,
                    name: this.$t('select_type')
                  }
                ],
                customIdOrImeiList: {
                    raw: '',
                    imei: [],
                    id: [],
                },
                distributorFilterPrefixFilterPrefix: '',
                filters: {
                    id: null,
                    imei: null,
                    customId: null,
                    type: null
                },
            }
        },
        computed: {
            criteriaInvalid() { return this.buildFilters() === null; },
        },
        beforeDestroy() { this.disposed = true; this.providerRequest++; this.lookupRequest++; this.distributorRequest++; this.criteriaVersion++; },
        watch: {
            filters: { deep: true, handler() { this.invalidateCriteria(); } },
            'customIdOrImeiList.raw'(value, previous) {
                if (typeof value === 'string' && typeof previous === 'string'
                    && formatBulkIdentifiers(value, { type: 'blur' }) === formatBulkIdentifiers(previous, { type: 'blur' })) return;
                this.invalidateCriteria(); this.currentPage = 1; this.refreshTable();
            },
            'filters.type'() { this.getDeviceChangeFirmwareList(); this.getDeviceChangeConfigurationList(); },
        },
        methods: {
            formatBulkIdentifiers,
            retryLoads() {
                this.operationError = false;
                this.getDeviceChangeFirmwareList(); this.getDeviceChangeConfigurationList(); this.getDeviceChangeDistributorList(); this.refreshTable();
            },
            getSelectedCount: function() {
                if (this.changeDevicesAvailable === false) {
                    return 0;
                }

                if (this.selectedCustomDeviceList.length > 0) {
                    return this.selectedCustomDeviceList.length;
                }

                return this.rows;
            },
            onRowSelect: function (event, id) {

                const index = this.selectedCustomDeviceList.indexOf(id);

                if (index === -1 && event) {
                    this.selectedCustomDeviceList.push(id)
                }

                if (index !== -1 && !event) {
                    this.selectedCustomDeviceList.splice(index, 1);
                }

                this.selectedCustomDeviceListSting = this.getSelectedCustomDeviceListSting();
            },
            getSelectedCustomDeviceListSting: function () {
                return this.selectedCustomDeviceList.join(', ');
            },
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            myProvider (ctx) {
                const request = ++this.providerRequest;
                if (this.buildFilters() === null || this.disposed) {
                    this.rows = 0; this.changeDevicesAvailable = false; this.isBusy = false; return Promise.resolve([]);
                }
                // console.log(ctx)
                // Here we don't set isBusy prop, so busy state will be
                // handled by table itself

                let params = '?page='
                    + ctx.currentPage
                    + '&rows=' + ctx.perPage
                    + '&sortBy=' + ctx.sortBy
                    + '&sortOrder=' + (ctx.sortDesc ? 'desc': 'asc')


                this.selectedCustomDeviceListSting = '';
                this.selectedCustomDeviceList = [];

                params = this.addFilters(params);

                this.isBusy = true
                let promise = axios.get('api/v1/devices/withTypeList' + params)

                return promise.then((data) => {
                    if (this.disposed || request !== this.providerRequest) return [];
                    const items = data.data.data
                    // Here we could override the busy state, setting isBusy to false
                    this.rows = data.data.records
                    this.changeDevicesAvailable = data.data.filtered

                    this.deviceTypeList = [
                          {
                              id: null,
                              name: this.$t('select_type')
                          }
                      ]

                    this.deviceTypeList = this.deviceTypeList.concat(data.data.deviceTypeList)

                    if (this.currentPage > 1 && items.length === 0) {
                        this.currentPage = 1;
                    }

                    this.isBusy = false

                    return(items)
                }).catch(error => {
                    if (!this.disposed && request === this.providerRequest) {
                        this.rows = 0; this.changeDevicesAvailable = false; this.isBusy = false;
                        if (error.response?.status !== 401) this.operationError = true;
                    }
                    // Here we could override the busy state, setting isBusy to false
                    // this.isBusy = false
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    // console.log(error)
                    return []
                })
            },
            invalidateCriteria() {
                if (this.isBusy) this.tableRefreshPending = true;
                this.providerRequest++; this.criteriaVersion++; this.changeDevicesAvailable = false; this.rows = 0;
                this.showSuccessAlertDeviceChangeFirmwareList = false;
                this.showSuccessAlertDeviceChangeConfigurationList = false;
                this.showSuccessAlertDeviceChangeDistributorList = false;
                this.operationError = false;
            },
            buildFilters() {
                const query = new URLSearchParams();
                for (const [field, value] of Object.entries(this.filters)) {
                    if (value !== null && value !== undefined && String(value).trim() !== '') query.set(field, String(value));
                }
                const raw = this.selectedCustomDeviceList.length ? this.selectedCustomDeviceList.join(',') : this.customIdOrImeiList.raw;
                if (typeof raw !== 'string') return null;
                const tokens = [...new Set(raw.trim().split(/[\s,.;:]+/).filter(Boolean))];
                if (tokens.some(token => !/^[0-9]{1,10}$/.test(token) && !/^[0-9]{15}$/.test(token))) return null;
                const ids = tokens.filter(token => token.length !== 15);
                const imeis = tokens.filter(token => token.length === 15);
                if (ids.length && imeis.length) return null;
                if (ids.length) query.set('customIdList', ids.join(','));
                if (imeis.length) query.set('imeiList', imeis.join(','));
                return query;
            },
            addFilters(params) {
                const query = this.buildFilters();
                if (!query || !query.toString()) return params;
                return params + (params.includes('?') ? (params.endsWith('?') ? '' : '&') : '?') + query.toString();
            },
            getDictionary: function(type) {
                if (type=== 'deviceType') {
                    return this.deviceTypeList
                }

                return []
            },
            refreshTable() {
                if (this.disposed || !this.$refs.deviceGroupActionsTable) return;
                if (this.isBusy) { this.tableRefreshPending = true; return; }
                this.tableRefreshPending = false;
                this.$refs.deviceGroupActionsTable.refresh();
            },
            onTableRefreshed() {
                if (this.disposed) return;
                this.isBusy = false;
                // BTable emits refreshed before its busy prop has propagated to the parent.
                // Wait for that render before replaying an update requested during a pending read.
                if (this.tableRefreshPending) this.$nextTick(() => this.refreshTable());
            },
            async getDeviceChangeFirmwareList() {
                const request = ++this.firmwareRequest;
                const type = this.filters.type;
                this.deviceChangeFirmware = null;
                this.deviceChangeFirmwareList = [{ id: null, version: this.$t('select_firmware') }];
                if (type === null || this.disposed) return;
                try {
                    const response = await axios.get('api/v1/firmwares/device-type/' + type, { timeout: REQUEST_TIMEOUT_MS });
                    if (this.disposed || request !== this.firmwareRequest || type !== this.filters.type) return;
                    if (!Array.isArray(response.data.rows)) throw new Error('Invalid target list');
                    this.deviceChangeFirmwareList.push(...response.data.rows);
                    this.deviceChangeFirmware = response.data.rows[0]?.id ?? null;
                    this.deviceChangeFirmwareListHash = Object.fromEntries(response.data.rows.map(item => [item.id, item]));
                } catch (error) {
                    if (!this.disposed && request === this.firmwareRequest && error.response?.status !== 401) this.operationError = true;
                }
            },
            getChangeFirmwareDescription() {
                if (this.deviceChangeFirmwareListHash[this.deviceChangeFirmware] !== undefined) {

                    return this.deviceChangeFirmwareListHash[this.deviceChangeFirmware].description;
                }

                return null;
            },
            async getDeviceChangeConfigurationList() {
                const request = ++this.configurationRequest;
                const type = this.filters.type;
                this.deviceChangeConfiguration = null;
                this.deviceChangeConfigurationList = [{ id: null, name: this.$t('select_configuration') }];
                if (type === null || this.disposed) return;
                try {
                    const response = await axios.get('api/v1/configurations/device-type/' + type, { timeout: REQUEST_TIMEOUT_MS });
                    if (this.disposed || request !== this.configurationRequest || type !== this.filters.type) return;
                    if (!Array.isArray(response.data.rows)) throw new Error('Invalid target list');
                    this.deviceChangeConfigurationList.push(...response.data.rows);
                    this.deviceChangeConfiguration = response.data.rows[0]?.id ?? null;
                } catch (error) {
                    if (!this.disposed && request === this.configurationRequest && error.response?.status !== 401) this.operationError = true;
                }
            },
            getDeviceChangeDistributorList: function () {
                const request = ++this.distributorRequest;
                this.deviceChangeDistributorAvailable = false;
                return axios
                    .get('api/v1/users/distibutors', { timeout: REQUEST_TIMEOUT_MS })
                    .then((data) => {
                        if (this.disposed || request !== this.distributorRequest) return;

                        let deviceChangeAllDistributorList = [
                            {
                                id: null,
                                name: this.$t('select_organisation'),
                                nameOrigin: '',
                                identity: null
                            }
                        ];

                        data.data.rows.forEach(
                            function (item) {
                                let distributor = item;
                                distributor.nameOrigin = distributor.name;
                                distributor.name = distributor.identity + ' | '+ distributor.name
                                deviceChangeAllDistributorList.push(distributor);
                            }
                        )

                        this.deviceChangeAllDistributorList = deviceChangeAllDistributorList;
                        this.deviceChangeDistributorList = deviceChangeAllDistributorList;

                        this.deviceChangeDistributor = null;

                        if (data.data.rows.length > 0) {
                            this.deviceChangeDistributor = null;
                        }

                        this.deviceChangeDistributorAvailable = true;

                    })
                    .catch(error => { if (!this.disposed && request === this.distributorRequest && error.response?.status !== 401) this.operationError = true; });
            },
            updateDevicesConfigurations() { return this.submitBulk('Configuration', this.deviceChangeConfiguration, this.deviceChangeConfigurationList, 'configuration'); },
            updateDevicesFirmware() { return this.submitBulk('Firmware', this.deviceChangeFirmware, this.deviceChangeFirmwareList, 'firmware'); },
            updateDevicesDistributors() { return this.submitBulk('Distributor', this.deviceChangeDistributor, this.deviceChangeDistributorList, 'distributor'); },
            async submitBulk(kind, target, options, operation) {
                if (this.disposed || this.sending || this.isBusy || this.rows < 1 || this.buildFilters() === null) return;
                if (!Number.isInteger(target) || target < 1 || target > 9999999999 || !options.some(item => item.id === target)) return;
                if (operation === 'distributor') {
                    if (!this.deviceChangeDistributorAvailable || !this.changeDevicesAvailable) return;
                } else if (!Number.isInteger(this.filters.type) || this.filters.type < 1 || this.filters.type > 9999999999) return;
                const version = this.criteriaVersion;
                const prefix = 'showSuccessAlertDeviceChange' + kind + 'List';
                this[prefix] = false; this.operationError = false; this.sending = true;
                const path = operation === 'distributor' ? 'api/v1/devices/update/distributor/' + target
                    : 'api/v1/devices/device-type/' + this.filters.type + '/update/' + operation + '/' + target;
                try {
                    const response = await axios.post(this.addFilters(path + '/by-criteria?'), undefined, { timeout: REQUEST_TIMEOUT_MS });
                    const count = response.data?.count;
                    if (!Number.isInteger(count) || count < 0) throw new Error('Invalid bulk command count');
                    this.$store.commit('clearDeviceList');
                    if (this.disposed || version !== this.criteriaVersion) return;
                    this[prefix + 'Count'] = count; this[prefix] = true; this.refreshTable();
                } catch (error) {
                    if (!this.disposed && version === this.criteriaVersion && error.response?.status !== 401) this.operationError = true;
                } finally { if (!this.disposed) this.sending = false; }
            },
            filterDistributorList: function () {
              let filtered = [
                {
                  id: null,
                  name: this.$t('select_organisation')
                }
              ];

              const distributorFilterPrefixFilterPrefix = this.distributorFilterPrefixFilterPrefix.trim()

              if (distributorFilterPrefixFilterPrefix.length < 1) {
                this.deviceChangeDistributorList = this.deviceChangeAllDistributorList

                return
              }

              this.deviceChangeAllDistributorList.forEach(
                  distibutor => {
                      // console.log(distibutor)
                      const name = distibutor.nameOrigin.trim();
                      let pushed = false;

                      let subStr = name.substr(0, distributorFilterPrefixFilterPrefix.length);
                      if (distributorFilterPrefixFilterPrefix.toLowerCase() === subStr.toLowerCase()) {
                          filtered.push(distibutor);
                          pushed = true;
                      }

                      if (!pushed) {
                          const identity = '' + distibutor.identity;

                          let identitySubStr = identity.substr(0, distributorFilterPrefixFilterPrefix.length);
                          if (distributorFilterPrefixFilterPrefix.toLowerCase() === identitySubStr.toLowerCase()) {
                              filtered.push(distibutor);
                          }
                      }
                  }

              )

              this.deviceChangeDistributorList = filtered;
            },
            initFutureAvailable() {
                let futureAvailable = {};

                if (localStorage.getItem('futureAvailable')) {
                    try {
                        futureAvailable = JSON.parse(localStorage.getItem('futureAvailable'));
                    } catch(e) {
                        localStorage.removeItem('futureAvailable');
                        return;
                    }
                }

                this.roleCrossSiteDeviceMoveAvailable = futureAvailable.roleCrossSiteDeviceMove;
                // this.deviceChangeDistributorAvailable = futureAvailable.deviceChangeDistributor;
            },
        },
        mounted() {

            this.initFutureAvailable();

            if (this.customIdOrImeiListRaw !== undefined ) {
                this.customIdOrImeiList.raw = typeof this.customIdOrImeiListRaw === 'string'
                    ? formatBulkIdentifiers(this.customIdOrImeiListRaw) : this.customIdOrImeiListRaw
            }

            // console.log(111)
            // console.log(this.$route.query.customIdOrImeiList)
            // if (this.$route.query.customIdOrImeiList !== undefined) {
            //
            //     this.customIdOrImeiList.raw = this.$route.query.customIdOrImeiList;
            // }
            // axios
            //     .get('api/v1/device-types')
            //     .then((data) => {
            //
            //         this.deviceTypeList = [
            //             {
            //                 id: null,
            //                 name: ''
            //             }
            //         ]
            //
            //         this.deviceTypeList = this.deviceTypeList.concat(data.data.rows);
            //         this.isBusy = false;
            //     })
            //     .catch(error => {
            //         if (error.response.status === 401) {
            //             router.replace({
            //                 path: '/login',
            //                 query: {redirect: router.currentRoute.fullPath},
            //             });
            //         }
            //     });

            this.getDeviceChangeDistributorList()
        }
    }
</script>

<style scoped>

</style>
